<template>
  <div>
    <!-- <ReserveTabs
      @onTabChange="ChangeMode"
      :activeTab="activeMode"
      :counters="counters"
    /> -->
    <QueueTabs 
      :tabs="{
        new: {important: true},
        processing: {important: false},
        calendar: {important: false},
      }"
      :counters="counters"
      :currentTab="activeMode"
      @tabChanged="v => activeMode = v"/>
    <div v-if="!isDesktop" class="reserve-mobile-container">
      <button
      class="btn-create-order"
      @click="showOrderCreateUI"
      v-if="activeMode == 'new' && !isDesktop"
    >
      + {{ $t("queue.create_order") }}
    </button>

      <ReserveCalendarModal
        :reservation="reserveModal"
        v-if="reserveModal"
        @onCloseModal="closeModal"
      />

      <div v-if="activeMode != 'calendar'">
        <div v-for="(group, index) in groups(reservations)" :key="index">
          <h5 v-if="activeMode == 'processing'" class="date-indicator">
            <hr />
            <span class="date">{{ formatGroupDate(group.date) }}</span>
            <hr />
          </h5>
          <div
            class="group-entity"
            v-for="(item, index) in group.entities"
            :key="index"
          >
            <ReservationCard
              :reservation="item.entity"
              v-if="item.type == 'reservation'"
            />
          </div>
        </div>
      </div>
      <div v-if="activeMode == 'calendar'" class="calendar-tab-container">
        <div>
          <Calendar
            @onDateSelect="dateChange"
            :reservationDates="reservationDates"
          />
        </div>
        <div class="calendar-sorted-reservations-container">
          <div
            v-for="reservation in reservations"
            class="calendar-sorted-reservation"
            :key="reservation._id"
            @click="ShowReservationModal(reservation)"
          >
            <span>{{ reservation.name }}</span>
            <span>{{ formatDateTime(reservation.created_at) }}</span>
          </div>
        </div>
      </div>
    </div>
    <div v-if="isDesktop" class="reserve-desktop-container">
      <div
        class="reservation-column"
        v-for="reservIndex in reservations.length - 1"
        :key="reservIndex"
      >
        <div
          v-for="(group, index) in groups(reservations[reservIndex - 1])"
          :key="index"
        >
          <h5 v-if="reservIndex == 2" class="date-indicator">
            <hr />
            <span class="date">{{ formatGroupDate(group.date) }}</span>
            <hr />
          </h5>
          <div
            class="group-entity"
            v-for="(item, index) in group.entities"
            :key="index"
          >
            <ReservationCard
              :reservation="item.entity"
              v-if="item.type == 'reservation'"
            />
          </div>
        </div>
      </div>
      <div class="reservation-column">
        <ReserveCalendarModal
          :reservation="reserveModal"
          v-if="reserveModal"
          @onCloseModal="closeModal"
        />
        <div>
          <Calendar
            @onDateSelect="dateChange"
            :reservationDates="reservationDates"
          />
        </div>
        <div class="calendar-sorted-reservations-container">
          <div
            v-for="reservation in reservations[2]"
            class="calendar-sorted-reservation"
            :key="reservation._id"
            @click="ShowReservationModal(reservation)"
          >
            <span>{{ reservation.name }}</span>
            <span>{{ formatDateTime(reservation.created_at) }}</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ReservationCard from "@/components/notifications/ReservationCard.vue";
import ReserveTabs from "@/components/ReserveTabs.vue";
import Calendar from "@/components/calendar/Calendar.vue";
import ReserveCalendarModal from "@/components/modals/ReserveCalendarModal.vue";
import QueueTabs from "@/components/QueueTabs.vue"

import moment from "moment";

export default {
  components: {
    ReservationCard,
    ReserveTabs,
    Calendar,
    ReserveCalendarModal,
    QueueTabs
  },
  data() {
    return {
      activeMode: "new",
      date: "",
      reserveModal: null,
    };
  },
  methods: {
    closeModal() {
      this.reserveModal = null;
    },
    ShowReservationModal(reservation) {
      this.reserveModal = reservation;
    },
    formatDateTime(date) {
      return moment(date).format("LT").split(" ")[0];
    },
    ChangeMode(mode) {
      this.activeMode = mode;
    },
    showOrderCreateUI() {
      this.$router.push('/create_reserve');
    },
    dateChange(date) {
      this.date = date;
    },
    formatGroupDate(raw) {
      const now = moment();
      const then = moment(raw);

      if (now.isSame(then, "day")) return "Сьогодні";
      if (now.subtract(1, "day").isSame(then, "day")) return "Вчора";

      return then.format("DD.MM");
    },
    groups(reservations) {
      let groups = [];
      if (!reservations.length) return [];

      let current = moment(reservations[0].created_at);
      let current_group = {
        date: current.toDate(),
        entities: [],
      };

      for (let i = 0; i < reservations.length; i++) {
        const new_current = moment(reservations[i].created_at);

        if (!new_current.isSame(current, "day")) {
          current = new_current;

          groups.push(current_group);

          current_group = {
            date: new_current.toDate(),
            entities: [],
          };
        }

        current_group.entities.push({
          type: "reservation",
          entity: reservations[i],
        });
      }
      groups.push(current_group);
      return groups;
    },
  },
  mounted() {
    this.$store.dispatch('reserve/fetchReservations');
  },
  computed: {
    isDesktop() {
      return window.innerWidth > 768;
    },
    reservations() {
      let reservations = this.$store.state.reserve.list;
      if (this.isDesktop) {
        return [
          reservations.filter((el) => el.status == "confirmed"),
          reservations.filter((el) => el.status == "accepted").reverse(),
          reservations.filter(
            (el) =>
              moment(el.reserve_date).isSame(this.date, "day") &&
              el.status == "accepted"
          ),
        ];
      }
      if (this.activeMode == "new") {
        return reservations.filter((el) => el.status == "confirmed");
      } else if (this.activeMode == "processing") {
        return reservations.filter((el) => el.status == "accepted");
      } else
        return reservations.filter(
          (el) =>
            moment(el.reserve_date).isSame(this.date, "day") &&
            el.status == "accepted"
        );
    },
    counters() {
      let reservations = this.$store.state.reserve.list;
      return {
        new: reservations.filter((el) => el.status == "confirmed").length,
        processing: reservations.filter((el) => el.status == "accepted").length,
        calendar: reservations.filter(
          (el) =>
            moment(el.reserve_date).isSame(this.date, "day") &&
            el.status == "accepted"
        ).length,
      };
    },
    reservationDates() {
      let reservations = this.$store.state.reserve.list;
      reservations = reservations.filter((el) => el.status == "accepted");
      if (!reservations.length) return [];
      let dates = [reservations[0].reserve_date];
      let fixedDate = reservations[0].reserve_date;
      for (let i = 0; i < reservations.length; i++) {
        if (!moment(fixedDate).isSame(reservations[i].reserve_date, "day")) {
          fixedDate = reservations[i].reserve_date;
          dates.push(reservations[i].reserve_date);
        }
      }
      return dates;
    },
  },
};
</script>

<style>
.reserve-mobile-container {
  
  padding-bottom: 24vh;
}
.date-indicator {
  display: flex;
  align-items: center;
  margin: 0 6.15763vh 2.46305vh 6.15763vh;
}
.date-indicator hr {
  width: 100%;
  margin: 0.98522vh 0;
}
.date {
  margin: 0 1.72413vh;
  font-size: 1.84729vh;
  line-height: 2.09359vh;
  color: #a4a3a1;
}

.calendar-sorted-reservations-container {
  padding: 1.231527093596059vh 0 0;
  overflow: auto;
}
.calendar-sorted-reservation:hover {
  cursor: pointer;
  background: #464646;
  color: #ededed;
}
.calendar-sorted-reservation {
  font-size: 2.463054187192118vh;
  line-height: 85.69%;
  display: flex;
  justify-content: space-between;
  margin: 0 2.463054187192118vh;
  padding: 1.6009852216748766vh 0.2vh;
  border-top: 1px solid #908f8d;
}
.calendar-sorted-reservation:last-child {
  border-bottom: 1px solid #908f8d;
}
.reserve-desktop-container {
  width: 100%;
  height: 100vh;
  display: flex;
}
.reservation-column {
  width: 34.097vw;
  height: 100vh;
  border-right: 1px solid #c4c4c4;
  padding: 11.111vw 0 5.694vw;
  overflow-y: auto;
}
.reservation-column:last-child {
  border: none;
  /* padding-top: 9.722vw; */
  padding-top: 8.722vw;
}
.reservation-column::-webkit-scrollbar {
  width: 0;
}

.btn-create-order {
  margin: 0 auto 2.95vh;
  width: 90%;
  font-size: 4.3vw;
  color: #1d1d1d;
  line-height: normal;
  font-weight: 500;
  display: block;
  padding: 1.5vh 0;
  border: 1px solid #1d1d1d;
  background: transparent;
  border-radius: 5vh;
}
@media screen and (min-width: 765px) {
  .btn-create-order {
    font-size: 1.6vw;
  }
  .date-indicator {
    margin: 0 5.556vw 1.389vw;
  }
  .date-indicator hr {
    margin: 0;
  }
  .calendar-sorted-reservations-container {
    padding: 1.389vw 0 1.389vw;
  }
  .calendar-sorted-reservations-container::-webkit-scrollbar {
    width: 0;
  }
  .calendar-sorted-reservation {
    width: 26.042vw;
    margin: 0 auto 0;
    font-size: 1.389vw;
    line-height: 85.69%;
  }
}
</style>